"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.getTotalIssueComments = exports.getPaginationState = exports.getIssueCommentsState = exports.getIssueComments = exports.getIsPostingIssueComment = exports.getIsLoadingIssueComments = exports.getHasNextIssueCommentsPage = exports.getHasIssueCommentsFetchErrored = exports.fetchIssueCommentsAction = exports.createIssueCommentAction = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _uuid = require("uuid");
var _fetchHelpers = require("../fetchHelpers");
var _types = require("../../../../sdk/types");
const initialState = {
  [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Initial,
  comments: [],
  pendingFetchRequestId: undefined,
  pendingCommentPostStatus: _fetchHelpers.FetchStatus.Initial
};
const issueCommentsSlice = (0, _toolkit.createSlice)({
  name: "comments",
  initialState,
  reducers: {
    issueCommentsFetchStart: (state, action) => {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Loading;
      state.pendingFetchRequestId = action.payload.requestId;
      if (state.currentIssueId !== action.payload.issueId) {
        state.comments = [];
        state.currentIssueId = action.payload.issueId;
        delete state.pagination;
      }
    },
    issueCommentsFetchSuccess: (state, action) => {
      const {
        requestId,
        response
      } = action.payload;
      if (requestId !== state.pendingFetchRequestId) {
        return;
      }
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      state.pagination = response.pagination;
      const comments = state.comments.concat(response.results);
      const uniqCommentsMap = {};
      for (const comment of comments) {
        const id = comment.id;
        if (!uniqCommentsMap[id]) {
          uniqCommentsMap[id] = comment;
        }
      }
      state.comments = [...Object.values(uniqCommentsMap)];
      state.pendingFetchRequestId = undefined;
    },
    issueCommentsFetchFailure: (state, action) => {
      const {
        requestId
      } = action.payload;
      if (requestId !== state.pendingFetchRequestId) {
        return;
      }
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Error;
      state.pendingFetchRequestId = undefined;
    },
    createIssueCommentStart: state => {
      state.pendingCommentPostStatus = _fetchHelpers.FetchStatus.Loading;
    },
    createIssueCommentSuccess: (state, action) => {
      const {
        comment
      } = action.payload;
      if (comment.issueId !== state.currentIssueId) {
        return;
      }
      state.pendingCommentPostStatus = _fetchHelpers.FetchStatus.Success;
      state.comments.unshift(comment);
      const {
        pagination
      } = state;
      if (pagination) {
        pagination.totalResults++;
        pagination.offset++;
      }
    },
    createIssueCommentFailure: state => {
      state.pendingCommentPostStatus = _fetchHelpers.FetchStatus.Error;
    }
  }
});
const reducer = exports.reducer = issueCommentsSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issueCommentsSlice.name;
const getIssueCommentsState = state => state[STATE_KEY];
exports.getIssueCommentsState = getIssueCommentsState;
const getIsLoadingIssueComments = exports.getIsLoadingIssueComments = (0, _toolkit.createSelector)(getIssueCommentsState, _fetchHelpers.isLoading);
const getHasIssueCommentsFetchErrored = exports.getHasIssueCommentsFetchErrored = (0, _toolkit.createSelector)(getIssueCommentsState, _fetchHelpers.isErrored);
const getPaginationState = exports.getPaginationState = (0, _toolkit.createSelector)(getIssueCommentsState, state => state.pagination);
const getHasNextIssueCommentsPage = exports.getHasNextIssueCommentsPage = (0, _toolkit.createSelector)(getIssueCommentsState, state => state.pagination ? state.comments.length < state.pagination.totalResults : true);
const getTotalIssueComments = exports.getTotalIssueComments = (0, _toolkit.createSelector)(getIssueCommentsState, state => state.pagination ? state.pagination.totalResults : 0);
const getIssueComments = exports.getIssueComments = (0, _toolkit.createSelector)(getIssueCommentsState, state => state.comments);
const getIsPostingIssueComment = exports.getIsPostingIssueComment = (0, _toolkit.createSelector)(getIssueCommentsState, state => state.pendingCommentPostStatus === _fetchHelpers.FetchStatus.Loading);
const {
  issueCommentsFetchStart,
  issueCommentsFetchFailure,
  issueCommentsFetchSuccess,
  createIssueCommentStart,
  createIssueCommentSuccess,
  createIssueCommentFailure
} = issueCommentsSlice.actions;
const fetchIssueCommentsAction = _ref => {
  let {
    issueId,
    offset = 0,
    shouldSortByClientCreated
  } = _ref;
  return async (dispatch, getState, _ref2) => {
    let {
      sdk
    } = _ref2;
    const requestId = (0, _uuid.v4)();
    const limit = offset === 0 ? 5 : 10; // 5 for initial load; 10 for rest
    const sortBy = {
      direction: _types.IssueSortingDirection.Desc,
      attribute: shouldSortByClientCreated ? _types.IssueSortingField.ClientCreatedAt : _types.IssueSortingField.CreatedAt
    };
    dispatch(issueCommentsFetchStart({
      requestId,
      issueId
    }));
    try {
      const response = await sdk.IssueComments.getAll(issueId, {
        offset,
        limit,
        sortBy
      });
      dispatch(issueCommentsFetchSuccess({
        response,
        requestId
      }));
      return true;
    } catch (err) {
      dispatch(issueCommentsFetchFailure({
        requestId
      }));
    }
  };
};
exports.fetchIssueCommentsAction = fetchIssueCommentsAction;
const createIssueCommentAction = (issueId, body) => async (dispatch, getState, _ref3) => {
  let {
    sdk
  } = _ref3;
  dispatch(createIssueCommentStart());
  try {
    const comment = await sdk.IssueComments.create(issueId, body);
    dispatch(createIssueCommentSuccess({
      comment
    }));
    return comment;
  } catch (err) {
    dispatch(createIssueCommentFailure());
    return null;
  }
};
exports.createIssueCommentAction = createIssueCommentAction;
//# sourceMappingURL=issueComments.js.map